export default __webpack_public_path__ + "static/media/100_19186.80ec9ab5.jpg";